<template>

  <b-col lg="12" class="">
    <b-card class="comment-card shadow-lg p-2  mt-3" v-for="comment in comments" :key="comment.id">
      <b-row >
        <b-col lg="6" md="5" sm="5">
          <h5>{{ comment.user.name+ ' ' + comment.user.last_name }}</h5>
        </b-col>
        <b-col lg="5" md="5" sm="5" class="text-lg-center text-md-center">
          <div class="d-inline" v-for="i in 5" :key="i">
            <b-icon icon="star-fill" font-scale=".75" class="d-inline" variant="warning" v-if="i<=comment.rate"/>
            <b-icon icon="star" font-scale=".75" class="d-inline" variant="warning" v-else/>
          </div>
        </b-col>
      </b-row>

      <b-col lg="12">
        <div v-html="comment.body"/>
      </b-col>

      <C15 v-if="comment.replies.length > 0" :comments="comment.replies"/>
    </b-card>
  </b-col>

</template>

<script>
export default {
  name: "C15",
  props: ['comments'],
}
</script>

<style scoped>
.comment-card {
  border-radius: 40px 0 40px 0;
  background: linear-gradient(var(--light-cyan), var(--light-cyan)) padding-box,
  linear-gradient(to left, var(--secondary), transparent) border-box;
  border: 1px solid transparent;
}
</style>